import '../../styles/components/tabs.scss'

class Tabs extends HTMLElement {
  constructor() {
    super();

    this.tabButtons = Array.from(this.querySelectorAll('tab-button'));
    
    let tabEvent = 'click';
    if(this.hasAttribute('on-hover')) {
      tabEvent = 'mouseenter'
    }

    this.tabButtons.forEach(button => {
      button.addEventListener(tabEvent, this.selecTab.bind(this));
    })
  }

  selecTab(event) {
    const newTabButton = event.currentTarget;
    const openedTab = this.querySelector('tab-item[opened]');

    const newTabId = newTabButton.getAttribute('tab-id');
    const openedTabId = openedTab.getAttribute('tab-id');

    const openedTabButton = this.querySelector(`tab-button[tab-id='${openedTabId}']`)
    const newTab = this.querySelector(`tab-item[tab-id='${newTabId}']`);
    
    if(!newTabButton.hasAttribute('opened')) {
      openedTabButton.removeAttribute('opened');
      newTabButton.setAttribute('opened', '');
    }

    if(!newTab.hasAttribute('opened')) {
      openedTab.removeAttribute('opened');
      newTab.setAttribute('opened', '');
    }
  }
}

try {
  customElements.define('tabs-container', Tabs);
}
catch(e) {
  console.log("tabs-container already defined", e)
}